import { createFileRoute, Outlet } from "@tanstack/react-router";

/** Layout route for /saved — renders the matched child (list or detail). */
function SavedLayout() {
  return <Outlet />;
}

export const Route = createFileRoute("/_authed/saved")({
  component: SavedLayout,
});
